<template>
  <section id="homeInfo">
    <div class="container">
      <div class="header">
        <h5>{{stateName}}</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" class="infoForm" autocomplete="off">
        <h5>Tell us a bit about yourself</h5>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <div class="titleContainer">
                <input :disabled="loading" type="radio" id="mr" value="Mr" v-model="title">
                <label for="mr">Mr</label>

                <input :disabled="loading" type="radio" id="mrs" value="Mrs" v-model="title">
                <label for="mrs">Mrs</label>

                <input :disabled="loading" type="radio" id="ms" value="Ms" v-model="title">
                <label for="ms">Ms</label>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="fName">
                First Name
                <span>*</span>
              </label>
              <input
              :disabled="loading"
                v-validate="'required'"
                v-model="name"
                id="fName"
                class="input"
                type="text"
                required
                v-on:keyup.enter="focusOut($event)"
              >
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="lName">
                Last Name
                <span>*</span>
              </label>
              <input
              :disabled="loading"
                v-validate="'required'"
                v-model="lastName"
                id="lName"
                class="input"
                type="text"
                required
                v-on:keyup.enter="focusOut($event)"
              >
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label>
                Identification
                <span>*</span>
              </label>
              <div class="titleContainer identification">
                <input :disabled="loading" type="radio" id="Birthday" value="Birthday" v-model="identification.type">
                <label for="Birthday">Birthday</label>

                <input :disabled="loading" type="radio" id="saId" value="SA ID" v-model="identification.type">
                <label for="saId">SA ID</label>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control" v-if="identification.type == 'SA ID'">
              <label for="idNumber">
                Identification Number
                <span>*</span>
              </label>
              <input
              :disabled="loading"
                id="idNumber"
                v-validate="'required|numeric'"
                class="input"
                type="number"
                v-model="identification.content"
                required
                v-on:keyup.enter="focusOut($event)"
              >
              <small v-if="this.stateName === 'Home Improver'">Used when you redeem your discounts</small>
            </div>
            <div class="control" v-if="identification.type == 'Birthday'">
              <label for="birthDate">
                Birth Date
                <span>*</span>
              </label>
              <input
              :disabled="loading"
                id="birthDate"
                v-validate="'required'"
                class="input"
                type="date"
                v-model="identification.content"
                required
                v-on:keyup.enter="focusOut($event)"
              >
              <small v-if="this.stateName === 'Home Improver'">Used when you redeem your discounts</small>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="fName">
                Mobile Number
                <span>*</span>
              </label>
              <input
                :disabled="loading"
                v-validate="'required'"
                v-model="mobileNumber"
                v-mask="'### ### ####'"
                id="fName"
                class="input"
                type="tel"
                :class="{'invalid': mobileExists}"
                @focus="clearError('mobile')"
                v-on:keyup.enter="focusOut($event)"
              >
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="lName">
                Email Address
              </label>
              <input
                :disabled="loading"
                id="lName"
                v-validate="'email'"
                class="input"
                type="email"
                :class="{'invalid': emailExists}"
                @focus="clearError('email')"
                v-model="email"
                v-on:keyup.enter="focusOut($event)"
              >
              <!-- <small v-if="this.stateName === 'Home Improver'">Used to send you your PaintBucks™ balance</small> -->
            </div>
          </div>
        </div>
        <div class="errorContainer">
          <div v-if="emailExists">The email address has been registered previously on our system. Please use another email address.</div>
          <div v-if="mobileExists">This mobile number has been registered previously on our system. Please use another mobile number.</div>
        </div>
      </form>
      <div class="actions">
        <button @click="back()" class="button" :disabled="loading">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toContactInfo()" class="button is-blue" :class="{'is-loading': loading}">Continue</button>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import { mask } from "vue-the-mask";
import alertify from "alertifyjs";
import axios from "axios";
import * as Sentry from "@sentry/browser";


export default {
  name: "individualinfo",
  directives: { mask },
  components: {
    CancelButton
  },
  data() {
    return {
      stateName: this.$store.state.loyaltyType,
      title: "Mr",
      name: null,
      lastName: null,
      identification: {
        type: "Birthday",
        content: null
      },
      mobileNumber: null,
      email: null,
      phoneValue: 0,
      preventNextIteration: false,
      emailExists: false,
      mobileExists: false,
      loading: false
    };
  },
  methods: {
    toContactInfo() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.loading = true
          axios
            .post(
              this.$store.state.apiBaseUrl + "/check",
              {mobile: this.mobileNumber, email: this.email}
            )
            .then(res => {
              console.log("ALL GOOD", res)
              this.loading = false
              this.$store.commit("STORE_PERSONAL_INFO", {
                loyaltyType: this.stateName,
                title: this.title,
                firstName: this.name,
                lastname: this.lastName,
                identification: this.identification,
                mobileNumber: this.mobileNumber,
                email: this.email
              });
              this.$router.push("/address");
            })
            .catch(err => {

              if(err.response && err.response.status == 422){
                // Error if email or mobile exists on api
                let errorMessage = err.response.data.errors
                console.warn("User Exists",errorMessage)
                if(errorMessage.email && errorMessage.email.length > 0){
                  alertify.error("Email already in use")
                  this.emailExists = true
                }
                if(errorMessage.mobile && errorMessage.mobile.length > 0){
                  alertify.error("Mobile already in use")
                  this.mobileExists = true
                }
              } else {
                alertify.error("An error occured trying to verify email and mobile number. Please check internet connection or contact support.");
                Sentry.captureException(err);
                console.error(err)
              }
              this.loading = false
            })
        }
      });
    },
    clearError(type){
      if(type == 'email'){
        this.emailExists = false
      }
      if(type == 'mobile'){
        this.mobileExists = false
      }
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    }
  },
  created() {
    if (this.$store.state.loyaltyType == "personal") {
      this.stateName = "Home Improver";
    } else {
      this.stateName = "Pensioner";
    }
  },
  mounted(){
    if(this.$store.state.personal.info.title != undefined) {
      this.title = this.$store.state.personal.info.title
      this.name = this.$store.state.personal.info.firstName
      this.lastName = this.$store.state.personal.info.lastname
      this.identification = this.$store.state.personal.info.identification
      this.mobileNumber = this.$store.state.personal.info.mobileNumber
      this.email = this.$store.state.personal.info.email
      console.log("setting values")
    }
  }
};
</script>